import { useState } from "react";
import api, { fmtMXNFull, todayLocal } from "@/lib/api";
import { X, DollarSign } from "lucide-react";
import { toast } from "sonner";

const METHODS = ["EFECTIVO", "TRANSFERENCIA", "DEPÓSITO", "TARJETA", "CHEQUE"];

export const WorkshopPayModal = ({ quote, onClose, onPaid }) => {
  const [method, setMethod] = useState("TRANSFERENCIA");
  const [date, setDate] = useState(todayLocal());
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post(`/workshop/quotes/${quote.id}/pay`, { payment_date: date, payment_method: method });
      toast.success(`${quote.folio} marcada como PAGADA (${method.toLowerCase()})`);
      onPaid();
    } catch (err) { toast.error(err.response?.data?.detail || "Error al registrar el pago"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="fixed inset-0 z-50 p-4 flex items-center justify-center" style={{ background: "rgba(5,8,18,0.85)", backdropFilter: "blur(6px)" }} onClick={onClose}>
      <div className="panel-strong w-full max-w-sm scan-line" onClick={(e) => e.stopPropagation()} data-testid="workshop-pay-modal">
        <div className="panel-header px-6 py-4 flex items-center justify-between">
          <div>
            <div className="label-mono" style={{ color: "var(--magenta)" }}>// REGISTRAR PAGO</div>
            <h2 className="font-display font-bold text-xl text-slate-100">{quote.folio} · {fmtMXNFull(quote.total)}</h2>
          </div>
          <button onClick={onClose} className="text-slate-500 hover:text-cyan-300"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div>
            <label className="label-mono block mb-1.5">Método de pago</label>
            <div className="grid grid-cols-2 gap-2">
              {METHODS.map((m) => (
                <button key={m} type="button" data-testid={`pay-method-${m}`} onClick={() => setMethod(m)}
                  className="px-2 py-2 rounded-sm text-[11px] uppercase tracking-widest font-semibold"
                  style={method === m ? { background: "var(--magenta)", color: "white" } : { color: "var(--text-dim)", border: "1px solid var(--border-2)" }}>
                  {m}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="label-mono block mb-1.5">Fecha de pago</label>
            <input type="date" required value={date} onChange={(e) => setDate(e.target.value)} className="w-full input-cyber px-3 py-2 text-sm" data-testid="pay-date" />
          </div>
          <div className="flex gap-2 justify-end pt-2">
            <button type="button" onClick={onClose} className="btn-ghost px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm">Cancelar</button>
            <button type="submit" disabled={submitting} data-testid="pay-confirm-btn" className="px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-1.5 disabled:opacity-50" style={{ background: "var(--magenta)", color: "white" }}>
              <DollarSign className="w-3.5 h-3.5" /> {submitting ? "Guardando…" : "Registrar pago"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WorkshopPayModal;
